import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';
import EInvoiceApp from './components/EInvoiceApp';
import Login from './components/Login';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/invoice/:id" element={<EInvoiceApp />} />
    </Routes>
    </div>
  );
}


export default App;
